export enum LandingPageView {
    LOGIN = 'login',
    RESEND_CONFIRMATION_EMAIL = 'resend-confirmation-email',
    QUOTATIONS = 'quotations'
}
